import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ButtonDirective } from '@ion-ui/atoms';
import { TranslateModule } from '@ngx-translate/core';
import { TuiNotification } from '@taiga-ui/core';
import { TuiIslandDirective } from '@taiga-ui/legacy';

import { AuthenticationService } from '../authentication.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonDirective, TuiIslandDirective, TuiNotification, TranslateModule, RouterLink],
})
export class SignInComponent {
  readonly authenticationService = inject(AuthenticationService);
  readonly route = inject(ActivatedRoute);

  authError: string;
  returnUrl: string | null = null;

  constructor() {
    const authenticationService = this.authenticationService;

    this.authError = authenticationService.getLastError();
    this.returnUrl = this.route.snapshot.queryParams?.['returnUrl'];
  }

  async signIn() {
    return this.authenticationService.signIn(this.returnUrl ?? '');
  }
}
